export function getItems(details) {
  let cid = details.company_id
  let items = [
    {to: {name: 'PublisherDashboard'}, label: 'Dashboard', icon: 'icon-Dashboard'},
    {to: {name: 'PublisherActivity', params: {cid: cid}}, label: 'Reports', icon: 'icon-Reports'},
    {to: {name: 'PublisherSettings', params: {cid: cid}}, label: 'Settings', icon: 'icon-Settings'},
    {to: {name: 'PublisherMediums', params: {cid: cid}}, label: 'Mediums', icon: 'icon-Mediums'},
    {to: {name: 'PublisherAdReview', params: {cid: cid}}, label: 'Ad Review', icon: 'icon-Reports'},
    {to: {name: 'PublisherExplorer', params: {cid: cid}}, label: 'Explorer', icon: 'icon-Reports'}
  ]
  return items
}



// WEBPACK FOOTER //
// ./src/publisher/menuitems.js